import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    id: "campaigns",
    class: "flex"
};
const _hoisted_2 = {
    key: 0,
    class: "admin-table"
};
const _hoisted_3 = { class: "colored-row" };
const _hoisted_4 = { class: "w-16" };
const _hoisted_5 = ["aria-labelledby"];
const _hoisted_6 = ["id"];
const _hoisted_7 = ["href"];
const _hoisted_8 = { class: "text-left" };
const _hoisted_9 = { class: "block" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = { class: "font-medium" };
const _hoisted_13 = { class: "sr-only" };
const _hoisted_14 = { class: "my-loading" };
const _hoisted_15 = { class: "no-results panel p-10 mt-4" };
const _hoisted_16 = { class: "text-center mt-4 text-sm text-slate-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = _resolveComponent("router-link");
    const _component_Loading = _resolveComponent("Loading");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Campaigns", -1)),
            _createElementVNode("nav", null, [
                (_ctx.permissions.isProgrammeManager())
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: { name: 'admin.campaign.create' },
                        class: "btn"
                    }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                _createTextVNode(" Create Campaign ", -1)
                            ]))]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ])
        ]),
        (_ctx.index.hasResults())
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                            _createElementVNode("table", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, "Name / Account"),
                                        _createElementVNode("th", { scope: "col" }, "Campaign Dates"),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " "),
                                        _createElementVNode("th", { scope: "col" }, " ")
                                    ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.index.getData(), (campaign) => {
                                        return (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                            _createElementVNode("td", _hoisted_4, [
                                                (_openBlock(), _createElementBlock("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    class: "h-10 w-10 text-slate-400 mx-auto",
                                                    fill: "none",
                                                    viewBox: "0 0 24 24",
                                                    stroke: "currentColor",
                                                    "stroke-width": "2",
                                                    role: "img",
                                                    focusable: "false",
                                                    "aria-labelledby": campaign.slug
                                                }, [...(_cache[2] || (_cache[2] = [
                                                        _createElementVNode("title", null, "Campaign", -1),
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                                                        }, null, -1)
                                                    ]))], 8, _hoisted_5))
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: "block font-medium",
                                                    id: campaign.slug
                                                }, _toDisplayString(campaign.name) + " (" + _toDisplayString(campaign.currency) + ")", 9, _hoisted_6),
                                                _createElementVNode("a", {
                                                    href: campaign.endpoint,
                                                    target: "_blank"
                                                }, _toDisplayString(campaign.endpoint), 9, _hoisted_7)
                                            ]),
                                            _createElementVNode("td", _hoisted_8, [
                                                _createElementVNode("div", _hoisted_9, [
                                                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "font-medium" }, "Campaign Start:", -1)),
                                                    _createTextVNode(" " + _toDisplayString(_ctx.f.formatDateShort(campaign.start_date)), 1)
                                                ]),
                                                (campaign.end_date)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "font-medium" }, "Campaign End:", -1)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.f.formatDateShort(campaign.end_date)), 1)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_11, "No end date"))
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(_ctx.f.statusBox(campaign.status.campaign_status))
                                                }, [
                                                    _createElementVNode("span", null, _toDisplayString(campaign.status.campaign_status), 1),
                                                    _cache[5] || (_cache[5] = _createElementVNode("span", null, [
                                                        _createElementVNode("span"),
                                                        _createElementVNode("span")
                                                    ], -1))
                                                ], 2)
                                            ]),
                                            _cache[7] || (_cache[7] = _createElementVNode("td", null, "   ", -1)),
                                            _createElementVNode("td", _hoisted_12, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'admin.campaign.manage', params: { account: campaign.account, slug: campaign.slug } }
                                                }, {
                                                    default: _withCtx(() => [
                                                        _cache[6] || (_cache[6] = _createTextVNode(" Manage Campaign", -1)),
                                                        _createElementVNode("span", _hoisted_13, ", " + _toDisplayString(campaign.name), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["to"])
                                            ])
                                        ]));
                                    }), 256))
                                ])
                            ])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Loading, { message: "Loading Campaigns" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#campaigns",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2",
                                    focusable: "true"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M5 10l7-7m0 0l7 7m-7-7v18"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-20 w-20 mx-auto",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                            })
                        ])
                    ], -1)),
                    _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Campaigns Available", -1)),
                    _createElementVNode("p", _hoisted_16, [
                        _cache[11] || (_cache[11] = _createTextVNode(" We could not find any campaigns, ", -1)),
                        _createVNode(_component_router_link, { to: { name: 'admin.campaign.create' } }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                    _createTextVNode("create one", -1)
                                ]))]),
                            _: 1
                        }),
                        _cache[12] || (_cache[12] = _createTextVNode(". ", -1))
                    ])
                ])
            ]),
            error: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ], 64));
}
